import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initMetaPixel } from "./utils/metaPixel";
import { initClarity } from "./utils/clarity";
import { initHeadMeta } from "./utils/headMeta";

// Resource hints (incl. the LCP image preload) must be in <head> before paint.
initHeadMeta();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-253" data-mp="2aacnp57da0d3" />);
}

// Load analytics right after the first paint so they never compete with the
// LCP image. Meta Pixel keeps all of its events (PageView, ViewContent,
// InitiateCheckout); Microsoft Clarity runs independently alongside it.
const startTracking = () => {
  initMetaPixel();
  initClarity();
};
if (typeof window !== "undefined") {
  if ("requestIdleCallback" in window) {
    (window as Window & {
      requestIdleCallback: (cb: () => void, opts?: {
        timeout: number;
      }) => number;
    }).requestIdleCallback(startTracking, {
      timeout: 2500
    });
  } else {
    window.setTimeout(startTracking, 1200);
  }
}